import Vue from 'vue'
import Router from 'vue-router'
import store from './store/store'
Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior () {
    return { x: 0, y: 0 }
  },
  routes: [

    {
      // =============================================================================
      // MAIN LAYOUT ROUTES
      // =============================================================================
      path: '',
      component: () => import('./layouts/main/Main.vue'),
      beforeEnter: requireAuth,
      meta: {
        requiresAuth: true
      },
      children: [
        // =============================================================================
        // Theme Routes
        // =============================================================================
        {
          path: '/',
          name: 'home',
          component: () => import('./views/Home.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/movies',
          name: 'movies',
          component: () => import('./views/movies/Movies.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/genres',
          name: 'genres',
          component: () => import('./views/Genres.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/groups',
          name: 'genres',
          component: () => import('./views/Groups.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/cast',
          name: 'cast',
          component: () => import('./views/Cast.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/comments',
          name: 'comments',
          component: () => import('./views/comments/Comments.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/stories',
          name: 'stories',
          component: () => import('./views/stories/Stories.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/login',
          name: 'login',
          component: () => import('./views/Login.vue'),
        },
        {
          path: '/slider',
          name: 'slider',
          component: () => import('./views/slider/Slider.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/stories/create',
          name: 'storiesCreate',
          component: () => import('./views/stories/create.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/collections',
          name: 'collections',
          component: () => import('./views/collections/Collection.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/ramadan',
          name: 'ramadan',
          component: () => import('./views/Ramadan.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/collections/create',
          name: 'collectionsCreate',
          component: () => import('./views/collections/Create.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/reels',
          name: 'reels',
          component: () => import('./views/reels/index'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/reels/create',
          name: 'reelsCreate',
          component: () => import('./views/reels/create'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/reels/import',
          name: 'reelsImport',
          component: () => import('./views/reels/import'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/episode/edit/:id',
          name: 'editEpisode',
          component: () => import('./views/seasons/edit'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/old_dash',
          name: 'old_dash',
          component: () => import('./views/old_dash'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/episode/add/:seasonId',
          name: 'addEpisode',
          component: () => import('./views/seasons/add'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/languages',
          name: 'languages',
          component: () => import('./views/Languages.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/notifications',
          name: 'notifications',
          component: () => import('./views/Notifications.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/movies/add',
          name: 'addMovie',
          component: () => import('./views/movies/add.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/movies/imdb',
          name: 'addMovieImdb',
          component: () => import('./views/movies/addImdb.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/movies/create',
          name: 'create',
          component: () => import('./views/movies/Create.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/movies/edit/:id',
          name: 'editMovie',
          component: () => import('./views/movies/Edit.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/page2',
          name: 'page-2',
          component: () => import('./views/Page2.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/tv',
          name: 'tv',
          component: () => import('./views/tv/index.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/tv/schedule',
          name: 'tvSchedule',
          component: () => import('./views/tv/schedule.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/reports',
          name: 'reports',
          component: () => import('./views/reports/index.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/contentBag',
          name: 'contentBag',
          component: () => import('./views/content_bag/content_bag.vue'),
          meta: {
            requiresAuth: true
          }
        }
      ]
    },
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
    {
      path: '',
      component: () => import('@/layouts/full-page/FullPage.vue'),
      children: [
        // =============================================================================
        // PAGES
        // =============================================================================
        {
          path: '/pages/login',
          name: 'page-login',
          component: () => import('@/views/pages/Login.vue')
        },
        {
          path: '/pages/error-404',
          name: 'page-error-404',
          component: () => import('@/views/pages/Error404.vue')
        }
      ]
    },
    // Redirect to 404 page, if no match found
    {
      path: '*',
      redirect: '/pages/error-404'
    }
  ]
})

function requireAuth (to, from, next) {
    if(to.matched.some(record => record.meta.requiresAuth)) {
    if (store.getters['auth/isLoggedIn']) {
      next()
      return
    }
    router.push("/pages/login", () => {});
  } else {
    next()
  }
}

router.afterEach(() => {

  // if(to.matched.some(record => record.meta.requiresAuth)) {
  //   if (store.getters['auth/isLoggedIn']) {
  //     next()
  //     return
  //   }
  //   router.push("/pages/login", () => {});
  // } else {
  //   next()
  // }
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
  
})

export default router
